export default __webpack_public_path__ + "static/media/download_p5.f1464833.jpg";